import React from 'react';
import { useRef } from 'react';
import emailjs from 'emailjs-com';
import {
  AiOutlineCalendar,
  AiOutlineMail,
  AiOutlineMobile,
} from 'react-icons/ai';
import { ToastContainer, toast } from 'react-toastify';
import './contact.css';

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_y0relzb',
        'template_qtswq6g',
        form.current,
        'puQZFDynb6NLw5giJ'
      )
      .then((res) => {
        if (res.status === 200) {
          toast('The email has been sent successfully.');
        }
      });
    e.target.reset();
  };

  return (
    <section id='contact'>
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className='container contact__container'>
        <div className='contact__options'>
          <article className='contact__option'>
            <AiOutlineMail className='contact__option-icon' />
            <h4>Email</h4>
            <h5>gerson.gold007@gmail.com</h5>
            <a
              href='mailto:gerson.gold007@gmail.com'
              target='_blank'
              rel='noreferrer'
            >
              Send a Message
            </a>
          </article>

          <article className='contact__option'>
            <AiOutlineMobile className='contact__option-icon' />
            <h4>Phone Number</h4>
            <h5>(903) 251-4636</h5>
            <a href='tel:+1903514636' target='_blank' rel='noreferrer'>
              Call Me
            </a>
          </article>

          <article className='contact__option'>
            <AiOutlineCalendar className='contact__option-icon' />
            <h4>Calendly</h4>
            <h5>Gerson Cordova</h5>
            <a
              href='https://calendly.com/gerson-cordova/30min'
              target='_blank'
              rel='noreferrer'
            >
              Book me
            </a>
          </article>
        </div>
        <form ref={form} onSubmit={sendEmail}>
          <input
            type='text'
            name='firstname'
            placeholder='Your First Name'
            required
          />
          <input
            type='text'
            name='lastname'
            placeholder='Your Last Name'
            required
          />
          <input type='email' name='email' placeholder='Your Email' required />
          <textarea
            name='message'
            rows='7'
            placeholder='Your Message'
            required
          ></textarea>
          <button type='submit' className='btn btn-primary'>
            Send Message
          </button>
        </form>
      </div>

      <ToastContainer />
    </section>
  );
};

export default Contact;
